import { InjectionToken } from '@angular/core';
import { ELlmResponseType } from '../enums';

export const ARTIFACT_TYPES: InjectionToken<Set<ELlmResponseType>> = new InjectionToken('ARTIFACT_TYPES');
